import { Alert, Snackbar } from '@mui/material';
import React, { useState } from 'react';

interface ErrorSnackbarProps {
  errorMessage: string;
  severity: 'success' | 'info' | 'warning' | 'error';
  onClose: () => void;
};

const ErrorSnackBar: React.FC<ErrorSnackbarProps> = ({ errorMessage, severity, onClose }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ width: '100%', maxWidth: 400, mb: { xs: 1, sm: 2 } }}
    >
      <Alert severity={severity} variant="filled" sx={{ width: '100%' }}>
        {errorMessage}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackBar;